<template>
  <div class="iframe-video">
		<app-full-sticky-bg isPlay />
		<iframe
			:src="url"
			allowfullscreen>
		</iframe>
	</div>
</template>

<script>
	import FullStickyBg from '@/components/fullStickyBg/fullStickyBg'

	export default {
		components: {
			appFullStickyBg: FullStickyBg
		},
		props: {
      url: {
        default: '',
        type: String
      }
    },
	}
</script>

<style lang="scss">
	.iframe-video {
		width: 100%;
		height: 100%;
		//padding-bottom: 56.25%;

		//@media (min-aspect-ratio: 16/9) {
			//height: 300%;
			//top: -100%;
		//}
		//@media (max-aspect-ratio: 16/9) {
		//	width: 300%;
		//	left: -100%;
		//}

		.full-sticky-bg {
			position: absolute;
			z-index: 5;
		}

		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border: none;
		}
	}
</style>
